import { Icon } from "components"
import { useMediaIsMobile } from "utils/helpers"
import { ControlButtonWrapper } from "modules/Call/components/ControlButtonWrapper"
import { MoreButtonMenu } from "modules/Call/components/HelpMoreMenuWrapper/MoreButtonMenu"

interface Props {
    onClick(): void
    isPsychotherapyMode?: boolean
    setIsPsychotherapyMode?: () => void
    onClickMoreButton?: (isOpen: boolean, tooltipRef: HTMLDivElement | null) => void
}

export function HelpMoreButton({
    onClick,
    onClickMoreButton,
    isPsychotherapyMode,
    setIsPsychotherapyMode,
}: Props) {
    const isMobile = useMediaIsMobile()
    return isMobile ? (
        <MoreButtonMenu
            onClick={onClick}
            onClickMoreButton={onClickMoreButton}
            isPsychotherapyMode={isPsychotherapyMode}
            setIsPsychotherapyMode={setIsPsychotherapyMode}
        />
    ) : (
        <ControlButtonWrapper isRounded>
            <button type="button" onClick={onClick}>
                <Icon className="p-0" type="help-circle-white" size={28} />
            </button>
        </ControlButtonWrapper>
    )
}
